import React, {Component} from 'react'
import f1 from "../../img/icons/1.png";
import f2 from "../../img/icons/2.png";
import f3 from "../../img/icons/3.png";
import f4 from "../../img/icons/4.png";
import strings from '../../strings/localeStrings'

export default class Onas extends Component {

    render() {
        return (
            <div className="onas container">
                <div className="row icons mobilkaFixRow" style={{marginBottom: 15}}>
                    <div className="col-sm-3">
                        <img src={f1}/>
                        <h3>{strings.czysteWnetrze}</h3>
                        <hr/>
                    </div>
                    <div className="col-sm-3">
                        <img src={f2}/>
                        <h3>{strings.zawszeNaCzas}</h3>
                        <hr/>
                    </div>
                    <div className="col-sm-3">
                        <img src={f3}/>
                        <h3>{strings.szybkieWifi}</h3>
                        <hr/>
                    </div>
                    <div className="col-sm-3">
                        <img src={f4}/>
                        <h3>{strings.kulturalniKierowcy}</h3>
                        <hr/>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Onas.js